import React from 'react';
import { formatMoney } from '../../helpers/formatters';

export const SearchItem = ({ item, onAddItem, addItemText }) => {
    const handleAddToCart = () => {
        onAddItem({
            product: item,
            quantity: 1
        });
    };

    return (
        <li className="list-group-item">
            <div className="row">
                <div className="col-md-1 col-lg-1">
                    <p className="text-center text-secondary mt-3 mt-md-0">
                        <i className={`fad fa-${item.icon} fa-2x`}></i>
                    </p>
                </div>
                <div className="col-md-3 col-lg-5 d-flex justify-content-between">
                    <label className="d-block d-md-none fw-bold">Name</label>
                    <p className="text-dark">{item.name}</p>
                </div>
                <div className="col-md-4 col-lg-3 d-flex justify-content-between">
                    <label className="d-block d-md-none fw-bold">Price</label>
                    <p className="text-success text-end w-100">{formatMoney(item.price)}</p>
                </div>
                <div className="col-md-4 col-lg-3">
                    <div className="d-grid">
                        <button
                            type="button"
                            onClick={handleAddToCart}
                            className="btn btn-outline-primary">
                            {addItemText}
                        </button>
                    </div>
                </div>
            </div>
        </li>
    );
};
